import React, { useState, useEffect } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ModalShowHistoryDetail from "./ModalShowHistoryDetail";
import Visibility from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { getActionLog } from "../Store/Actions/ChatAction";
import { toast } from "react-toastify";
import moment from "moment";
import { Icon } from "@iconify/react";

const HistoryDetailModal = ({ onClose, OutboundContactID }) => {
  const initials = {
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
  };
  const [pageHistoryDetail, setPageHistoryDetail] = useState(initials);
  {
    console.log("pageHistoryDetail:", pageHistoryDetail);
  }

  useEffect(() => {
    const fetchDataHistoryDetail = async () => {
      setPageHistoryDetail((old) => ({ ...old, isLoading: true }));
      const response = await getActionLog(
        OutboundContactID,
        pageHistoryDetail.page
      );
      if (response.status) {
        setPageHistoryDetail((old) => ({
          ...old,
          isLoading: false,
          data: response.data.records,
          total: response.data.total,
        }));
      } else {
        toast.warn(response.error);
      }
    };
    fetchDataHistoryDetail();
  }, [OutboundContactID, pageHistoryDetail.page, pageHistoryDetail.pageSize]);

  const clearState = () => {
    setPageHistoryDetail({ ...initials });
    onClose();
  };
  const [openModal, setOpenModal] = useState(false);
  const [loadComments, setComments] = useState("");

  const buttonAction = (comments) => {
    setOpenModal(true);
    setComments(comments);
  };

  const ActionButton = ({ value, comments }) => {
    if (value === "WHATSAPP") {
      return (
        <IconButton onClick={() => buttonAction(comments)}>
          <Visibility />
        </IconButton>
      );
    }
  };

  const Actiontype = ({ value }) => {
    switch (value) {
      case "INBOUND":
        return (
          <Icon
            icon="solar:incoming-call-outline"
            color="#727272"
            width="28"
            height="28"
          />
        );
      case "MANUALCALL":
        return (
          <Icon
            icon="mingcute:phone-call-line"
            color="#727272"
            width="28"
            height="28"
          />
        );
      case "AUTOMATICCALL":
        return (
          <Icon
            icon="solar:chat-round-call-bold-duotone"
            width="28"
            height="28"
          />
        );
      case "WHATSAPP":
        return <Icon icon="logos:whatsapp-icon" width="28" height="28" />;
      case "FACEBOOK":
        return <Icon icon="logos:facebook" width="28" height="28" />;
      case "TWITTTER":
        return <Icon icon="logos:twitter" width="28" height="28" />;
    }
  };

  const columns = [
    {
      field: "Time",
      headerName: "Time",
      flex: 1.4,
      minWidth: 160,
      renderCell: (params) =>
        `${moment.utc(params.row.Time).format("DD-MMM-yyyy HH:mm:ss")}`,
    },
    {
      field: "ActionType",
      headerName: "Action Type",
      flex: 0.7,
      minWidth: 60,
      renderCell: (params) => <Actiontype value={params.row.ActionType} />,
    },
    { field: "AgentName", headerName: "By Agent", flex: 1, minWidth: 100 },
    { field: "Duration", headerName: "Duration", flex: 0.5, minWidth: 80 },
    { field: "Address", headerName: "Phone Number", flex: 1.2, minWidth: 100 },
    { field: "ActionCode", headerName: "Action No", flex: 1.2, minWidth: 100 },
    { field: "State", headerName: "State", flex: 1, minWidth: 100 },
    {
      field: "Comments",
      headerName: "Comments",
      flex: 1.8,
      sortable: false,
      minWidth: 100,
    },
    {
      field: "Action",
      headerName: "",
      flex: 0.5,
      minWidth: 50,
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <ActionButton
          value={params.row.ActionType}
          comments={params.row.Comments}
        />
      ),
    },
  ];

  return (
    <div className="overlayHistory">
      <ModalShowHistoryDetail
        open={openModal}
        loadComments={loadComments}
        onClose={() => setOpenModal(false)}
      ></ModalShowHistoryDetail>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainerHistoryDetail"
      >
        <CloseOutlinedIcon
          className="closeBtn"
          onClick={clearState}
        ></CloseOutlinedIcon>
        <div className="contentCampaignDetail">
          <h3
            style={{
              color: "gray",
              alignSelf: "center",
              marginBottom: "26px",
              fontSize: 22,
            }}
          >
            History Detail
          </h3>
          <div className="contentHistoryDetail">
            <DataGrid
              rows={pageHistoryDetail.data}
              rowCount={pageHistoryDetail.total}
              loading={pageHistoryDetail.isLoading}
              rowsPerPageOptions={[10]}
              pagination
              page={pageHistoryDetail.page - 1}
              pageSize={pageHistoryDetail.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageHistoryDetail((old) => ({ ...old, page: newPage + 1 }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageHistoryDetail((old) => ({
                  ...old,
                  pageSize: newPageSize,
                }))
              }
              columns={columns}
              disableColumnMenu
              disableColumnFilter
              disableSelectionOnClick
              sx={{
                [`& .${gridClasses.cell}`]: {
                  py: 1.8,
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryDetailModal;
